import React from 'react';

import { useBonusContext } from '../../../contexts/BonusContext';

export const useRewards = () => {
	const { draftstarsRewards, wageringRewards, activeBrand } = useBonusContext();

	const boostUpBonusList = React.useMemo(
		() =>
			wageringRewards.filter(
				(item) => item.type === 'boosts' && (item.attributes.active_count ?? 0) > 0
			) as Array<PromotionBoost>,
		[wageringRewards]
	);

	const ticketList = React.useMemo(
		() => draftstarsRewards.filter((item) => item.type === 'bonuses') as Array<PromotionBonus>,
		[draftstarsRewards]
	);

	const promotionsBonusList = React.useMemo(
		() =>
			activeBrand === 'Betting'
				? (wageringRewards.filter((item) => item.type === 'promotion_offers') as Array<PromotionOffer>)
				: (draftstarsRewards.filter((item) => item.type === 'promotion_offers') as Array<PromotionOffer>),
		[activeBrand, wageringRewards, draftstarsRewards]
	);

	// legacy promotions, safe to remove once backend has migrated
	const legacyPromotionsBonusList = React.useMemo(
		() =>
			activeBrand === 'Betting'
				? (wageringRewards.filter((item) => item.type === 'promotions') as Array<LegacyPromotionOffer>)
				: (draftstarsRewards.filter((item) => item.type === 'promotions') as Array<LegacyPromotionOffer>),
		[activeBrand, wageringRewards, draftstarsRewards]
	);

	const wageringRewardCounts = React.useMemo(() => {
		const boostCount = wageringRewards.reduce((acc, item) => {
			if (item.type === 'boosts') return acc + item.attributes.active_count;

			return acc;
		}, 0);

		return (
			boostCount +
			wageringRewards.filter((item) => item.type === 'promotions' || item.type === 'promotion_offers').length
		);
	}, [wageringRewards]);

	const isNoRewards = React.useMemo(() => {
		if (
			activeBrand === 'Betting' &&
			promotionsBonusList.length + legacyPromotionsBonusList.length === 0 &&
			boostUpBonusList.length === 0
		) {
			return true;
		} else if (
			activeBrand === 'Fantasy' &&
			promotionsBonusList.length + legacyPromotionsBonusList.length === 0 &&
			ticketList.length === 0
		) {
			return true;
		}
		return false;
	}, [
		activeBrand,
		boostUpBonusList.length,
		promotionsBonusList.length,
		legacyPromotionsBonusList.length,
		ticketList.length,
	]);

	return {
		boostUpBonusList,
		ticketList,
		promotionsBonusList,
		legacyPromotionsBonusList,
		wageringRewardCounts,
		isNoRewards,
	};
};
